<template>
 <div>
     <div class="card-body">
         <div class="alert alert-success" role="alert" v-if="code_sent=='Y'">
             Verification code was sent awaiting verification.
         </div>
         Before proceeding, please verify your account.
         <div class="row" v-if="code_verified=='N'">
             <div class="col-md-4" v-if="use_phone">
                 <a href="" @click.prevent="sbVerify('sms')" :class="code_sent=='Y'?'btn btn-primary btn-block disabled':'btn btn-primary btn-block'">SMS Verification</a>
             </div>
             <div class="col-md-4" v-if="use_email">
                 <a href="" @click.prevent="sbVerify('email')" :class="code_sent=='Y'?'btn btn-primary btn-block disabled':'btn btn-primary btn-block'">Email Verification</a>
             </div>
             <div class="col-md-4" v-if="use_code">
                 <a href="" @click.prevent="sbVerify('employer')" :class="code_sent=='Y'?'btn btn-primary btn-block disabled':'btn btn-primary btn-block'">Code given by the Employer</a>
             </div>
         </div>
         <div class="row" v-else>
             <div class="col-md-10 offset-md-1">
                 <a href="/register-profile" class="btn btn-primary btn-block">Continue Registration</a>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:['phone','email','sent','verified'],
        mounted() {
            if(this.code_sent=='Y' && this.code_verified=='N'){
                this.timer = setInterval(() => {
                    this.checkDeviceValidation()
                }, 10000)
            }
        },
        data(){
            return {
                route: '/api/user-verify',
                route_validation: '/api/check-validation',
                use_phone:this.phone,
                use_email:this.email,
                use_code:'Y',
                code_sent:this.sent,
                code_verified:this.verified,
                timer: null
            }
        },
        methods:{
            log(s){
                console.log(s)
            },
            sbVerify(type){
                this.$http.post(this.route, {'type':type})
                    .then(function(response) {
                        this.code_sent='Y';
                        this.timer = setInterval(() => {
                            this.checkDeviceValidation()
                        }, 10000)
                    }, (response) => {
                        this._handleErrors(response.data, '#note-form')
                    })
            },
            checkDeviceValidation:function (){
                this.$http.post(this.route_validation)
                    .then(function(response) {
                        if (response.data.Status){
                            this.code_sent='Y';
                            this.code_verified='Y';
                            clearInterval(this.timer)
                        }
                    }, (response) => {
                        this._handleErrors(response.data, '#note-form')
                    })

            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
